import {
  LevelLocation,
  STEP_LOCATION,
  TYPE_REDUCER,
  ThreeLevelLocation,
  useTenantConfig,
} from 'contexts';
import * as React from 'react';
import { CommonRegionPickerProps } from 'types';
import { PopupThreeLevelLocationPickerMobile } from './mobile/PopupThreeLevelLocationPicker';
import { PopupThreeLevelLocationPickerDesktop } from './desktop/PopupThreeLevelLocationPickerDesktop';

export type PopupThreeLevelLocationPickerProps = Pick<
  CommonRegionPickerProps,
  'showPopup' | 'onClosePopup'
> & {
  threeLevelLocation: ThreeLevelLocation;
  updateThreeLevelLocation?: (action: {
    type: TYPE_REDUCER;
    value: LevelLocation;
  }) => void;
  stepLocation?: STEP_LOCATION;
  setStepLocation?: (stepLocation: STEP_LOCATION) => void;
  onSubmitNewLocation?: (
    newThreeLevelLocation: ThreeLevelLocation,
  ) => Promise<void>;
  correctThreeLevelLocation?: ThreeLevelLocation | null;
};
export const PopupThreeLevelLocationPicker = ({
  ...props
}: PopupThreeLevelLocationPickerProps) => {
  const { isMobile } = useTenantConfig();
  if (isMobile) {
    return <PopupThreeLevelLocationPickerMobile {...props} />;
  }

  return <PopupThreeLevelLocationPickerDesktop {...props} />;
};
